export default {
  search: 'Zoeken',
  from: 'Na',
  to: 'Voor'
};
